import api from "../api";

const endpoint = "/WebsiteRestController/";
export const AppService = {
  async downloadUserGuid() {
    try {
      const response = await api.get(endpoint + "candidature_guide", {
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      return error.response?.data;
    }
  },
  async insert(data) {
    throw new Error("Méthod not implemented.");
  },
  async update(input) {
    throw new Error("Méthod not implemented.");
  },
  async findOneById(id) {
    throw new Error("Méthod not implemented.");
  },
  async list(filtre) {
    throw new Error("Méthod not implemented.");
  },
  async delete(id) {
    throw new Error("Méthod not implemented.");
  },
  async create(data) {
    throw new Error("Method not implemented.");
  },
  async softDelete(data) {
    throw new Error("Method not implemented.");
  },
  async hardDelete(data) {
    throw new Error("Method not implemented.");
  },
  async restore(data) {
    throw new Error("Method not implemented.");
  },
};
